import { ICalendarDateRange } from '@models';
import { Unavailability } from '@services';
import { useStore } from '@stores';
import dayjs from 'dayjs';
import { useEffect, useMemo } from 'react';

export const useCalendarUnavailability = (
  date: ICalendarDateRange | undefined
): Unavailability[] => {
  const { unavailabilityStore } = useStore();
  const { calendarUnavailability } = unavailabilityStore;

  const range = useMemo(() => {
    if (!date) return null;

    const startOfMonth = dayjs(date.startAt).startOf('month');
    const endOfMonth = dayjs(date.endAt).endOf('month');

    const key = `${startOfMonth.month()}-${endOfMonth.month()}`;

    return { key, startAt: startOfMonth.format(), endAt: endOfMonth.format() };
  }, [date]);

  useEffect(() => {
    range &&
      unavailabilityStore.getAllCalendar({
        startAt: range?.startAt,
        endAt: range?.endAt,
      });
  }, [unavailabilityStore, range?.key]);

  return Array.from(calendarUnavailability.values());
};
